<template>
    <AuthenticationBasic :title="$t('authentication.setPassword')">
        <v-form ref="form" v-model="valid">
            <v-text-field
                    v-model="password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :label="$t('authentication.newPassword')"
                    :rules="[$validations.required, $validations.password]"
                    :type="showPassword ? 'text' : 'password'"
                    name="newPassword"
                    required
                    @keyup.enter="resetPassword"
                    @click:append="showPassword = !showPassword"/>
            <v-text-field
                    v-model="repeatPassword"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :label="$t('authentication.repeatNewPassword')"
                    :rules="[$validations.required, $validations.password]"
                    :type="showPassword ? 'text' : 'password'"
                    name="repeatNewPassword"
                    required
                    @keyup.enter="resetPassword"
                    @click:append="showPassword = !showPassword"/>
            <v-btn
                    :disabled="loading"
                    :loading="loading"
                    block
                    class="mt-5 elevation-5 accentText--text"
                    color="accent"
                    large
                    @click="resetPassword">
                {{ $t('authentication.setPassword') }}
            </v-btn>
        </v-form>
    </AuthenticationBasic>
</template>

<script>
import AuthenticationBasic from "@/components/Authentication/AuthenticationBasic";

export default {
  name: "ResetPassword",
  components: {AuthenticationBasic},
  data() {
    return {
      loading: false,
      valid: false,
      sentMail: false,
      password: '',
      repeatPassword: '',
      showPassword: false,
    };
  },
  computed: {
    passwordConfirmationRule() {
      return () => (this.password === this.repeatPassword) || this.$t('authentication.passwordsNotMatch');
    }
  },
  methods: {
    resetPassword() {
      this.$refs.form.validate();
      if (!this.valid) {
        return;
      }
      const url = this.$store.getters.getUrl('resetPassword');

      this.loading = true;
      this.axios.put(url, {
        token: this.$route.params.token,
        password: this.password,
        confirmPassword: this.repeatPassword,
      }).then(() => {
        this.$store.dispatch('addNotification', {
          type: 'success',
          message: this.$t('success.resetPasswordSuccess')
        });
        this.$router.push({name: 'login'});
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped>

</style>